import type { TFormData } from "@/models/themes.model"

import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { configQueryOptions } from "@/queries/theme.factory"

export function useConfigurationsQuery() {
  const query = useQuery(configQueryOptions.all)

  const globalSettings = useMemo(() => {
    return query.data?.reduce((acc, curr) => {
      acc[curr.code] = curr.value
      return acc
    }, {} as TFormData)
  }, [query.data])
  const grsSettings = useMemo(() => {
    return query.data?.filter(setting => setting.category === "grs").reduce((acc, curr) => {
      acc[curr.code] = curr.value
      return acc
    }, {} as TFormData)
  }, [query.data])
  return {
    query,
    data: query.data,
    settings: globalSettings,
    grsSettings,
  }
}
